import { Direction } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { getPersonName } from '../utils/get-person-name';
import { useGetPatient } from './use-get-patient';
import { useGetUserFromUserId } from './use-get-user-from-user-id';

type Props = {
  patientId?: string;
  userId?: string;
  direction?: Direction;
};

export const useGetCitationPersonName = ({ patientId, userId, direction }: Props) => {
  const messageOutbound = direction === Direction.DIRECTION_OUTBOUND;
  const { patient, isLoading: isFetchingPatient } = useGetPatient(messageOutbound ? undefined : patientId);
  const { data: senderDetails, isFetching: isFetchingSender } = useGetUserFromUserId(
    userId,
    messageOutbound && !!userId
  );

  const personName = getPersonName(patient, messageOutbound && !userId ? 'AI Receptionist' : senderDetails);

  return { personName, isLoading: isFetchingPatient || isFetchingSender };
};
